import { IconWrapper } from '../runtime';
export default IconWrapper('arrow-left', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M10 3.24991L5.5 8L10 12.7499",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});